<template>
  <div>
    <div class="inner_about">
      <h3 class="form">Mail</h3>
      <p>お問い合わせはメールでご連絡をお願いします。</p>
      <p>For inquiries, please contact me by email.</p>
      <a href="mailto:snowdoke@gmail.com">
        <img class="mail" src="@/assets/mail_black.png" />
      </a>
    </div>
    <p class="copyright">© Yukidoke All Rights Reserved.</p>
  </div>
</template>

<script>
if (document.URL.match("/contact/")) {
  document.addEventListener("DOMContentLoaded", function() {
    document.getElementById("contact_click").click();
  });
}
</script>